import { SharedConstants } from "../../../../constants/shared.constants";
export class AttachemntMngView {
    id;
    description;
    fileName;
    attachmentType;
    date;
    link;
    revision;
    allowAccess;
    constructor(attachment, datePipe) {
        this.id = attachment.id;
        this.description = attachment.description;
        this.fileName = attachment.fileName;
        this.attachmentType = attachment.attachmentType;
        this.date = datePipe.transform(attachment.date, SharedConstants.SYSTEM_DATE_FORMAT_DEFAULT);
        this.link = attachment.link;
        this.revision = attachment.revision;
        this.allowAccess = attachment.allowAccess;
    }
}
